import React, {
  useContext,
  createContext,
  useReducer,
  useEffect,
  useRef,
  useState,
} from 'react';
import FullCard from '../../../../../../components/Card/FullCard';
import Form from './Form';
import Button from '@material-ui/core/Button';
import { useParams, useLocation, useHistory } from 'react-router-dom';
import checkCodeMelli from '../../../../../../fns/isValidNationalCode';
import checkMobile from '../../../../../../fns/checkMobilePhone';
import { store as mainStore } from '../../../../../../store';
import axios from 'api/axios';
import { isMobile } from 'react-device-detect';
import WorkTime from './WorkTime';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import JsonComponent from '../../../../../../components/OtherElements/JsonComponent';
import Rules from './Rules/Rules';
import useRules from '../../../../../../hooks/useRules';
import useTitle from 'hooks/useTitle';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
    gridGap: theme.spacing(1),
    '& > div': {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridGap: theme.spacing(1),
    },
    alignItems: 'start',
  },
}));

export const store = createContext(null);
const { Provider } = store;

const AddOperator = () => {
  const classes = useStyles();
  const [rules, hasRule, isAdmin] = useRules();
  const isFirstRender = useRef(true);
  const { id } = useParams();
  const history = useHistory();
  const mode = id ? 'edit' : 'add';
  useTitle(mode === 'add' ? 'افزودن کارشناس حمل' : 'ویرایش کارشناس حمل');

  const initialState = {
    values: {
      firstName: '',
      lastName: '',
      nationalCode: '',
      mobilePhone: '',
      username: '',
      password: '',
      commissionShare: '',
      workTime: null,
      voipExt: '',
      voipExt2: '',
    },
    error: {},
    categories: [],
    category: null,
    rules: [],
    selectedRules: [],
  };
  const [state, dispatch] = useReducer(reducer, initialState);
  const selectedRules = state.selectedRules;
  const { showMessage, showError } = useContext(mainStore);
  const [loading, setLoading] = useState(false);

  function reducer(state, action) {
    const { type, payload } = action;
    switch (type) {
      case 'CHANGE_FIELD':
        return { ...state, values: { ...state.values, ...payload } };
      case 'ERROR':
        return { ...state, error: payload };
      case 'LOAD':
        return { ...state, values: payload };
      case 'CHANGE_WORK_TIME':
        return { ...state, values: { ...state.values, workTime: payload } };
      case 'CATEGORIES':
        return { ...state, categories: payload };
      case 'SELECT_CATEGORY':
        return { ...state, category: payload };
      case 'DESELECT_CATEGORY':
        return { ...state, category: null };
      case 'RULES':
        return {
          ...state,
          rules: payload.rules,
        };
      case 'SELECT_RULES':
        const selectedRules = state.selectedRules;
        const rules = payload;
        let _rules = [];
        for (const rule of selectedRules) {
          if (!rules.includes(rule)) _rules.push(rule);
        }
        for (const rule of rules) {
          if (!selectedRules.includes(rule)) {
            _rules.push(rule);
          }
        }
        return { ...state, selectedRules: _rules };
      // let selectedRules = state.selectedRules;
      // const rules = payload;
      // for(const rule of rules){
      //   const index = selectedRules.indexOf(rule)
      //   if(index>-1){
      //     selectedRules.splice(index,1);
      //   }else selectedRules.push(rule)
      // }
      // return {...state}
      default:
        return state;
    }
  }
  const validation = (e) => {
    const isSingleValidation = e || false;
    let er = {};

    // Validation patterns start here:
    if (!state.values.firstName || state.values.firstName.length < 2) {
      er.firstName = 'نام بایستی حداقل ۲ داشته باشد.';
    }
    if (!state.values.lastName || state.values.lastName.length < 3) {
      er.lastName = 'نام بایستی حداقل ۳ داشته باشد.';
    }
    const mobile = checkMobile(state.values.mobilePhone);
    if (mobile === false) {
      er.mobilePhone = 'شماره موبایل صحیح وارد نمائید.';
    } else {
      dispatch({ type: 'CHANGE_FIELD', payload: { mobilePhone: mobile } });
    }
    if (!state.values.username || state.values.username.length < 3) {
      er.username = 'نام کاربری بایستی حداقل ۳ کاراکتر داشته باشد.';
    }
    if (mode === 'add' && !state.values.password) {
      er.password = 'گذرواژه الزامی است';
    }

    if (isSingleValidation) {
      let err = {};

      for (const v in state.values) {
        if (state.values[v]) {
          if (er[v]) {
            err[v] = er[v];
          }
        }
      }
      if (Object.entries(err).length) {
        dispatch({ type: 'ERROR', payload: err });
        return false;
      }
      {
        dispatch({ type: 'ERROR', payload: {} });
        return true;
      }
    } else {
      if (Object.entries(er).length) {
        dispatch({ type: 'ERROR', payload: er });
        return false;
      }
      dispatch({ type: 'ERROR', payload: er });
      return true;
    }
  };
  const handleSubmit = async () => {
    if (validation()) {
      try {
        setLoading(true);
        if (mode === 'add') {
          const { data } = await axios.post(
            `/api/v1/admin/users/operator`,
            state.values
          );
          showMessage(data.messages);
          history.replace(`/protected/admin/users/admin/${data.values._id}`);
        } else {
          let { data } = await axios.post(`/api/v1/admin/operators/profile`, {
            _id: id,
            ...state.values,
          });
          showMessage(data.messages);
        }
      } catch (error) {
        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.code === 11000
        ) {
          showError('کاربری دیگر با این شماره موبایل موجود می باشد.');
          return;
        }
        showError(error);
      } finally {
        setLoading(false);
      }
    } else {
      showError('خطاهای مشخص شده را بررسی کنید.');
    }
  };
  const handleFetchUser = async () => {
    try {
      const { data } = await axios.get(`/api/v1/admin/operators/${id}`);
      if (data?.values) dispatch({ type: 'LOAD', payload: data?.values });
    } catch (error) {
      showError(error);
    }
  };
  const handleChangeWorkTime = (workTime) => {
    dispatch({ type: 'CHANGE_WORK_TIME', payload: workTime });
  };
  async function loadCategories() {
    try {
      const { data } = await axios.get(
        `/api/v1/admin/operators/rules/${id}/categories`
      );
      const { categories, selected } = data;
      for (const category of categories) {
        category.count = selected[category._id];
      }
      dispatch({ type: 'CATEGORIES', payload: categories });
    } catch (error) {
      showError(error);
    }
  }
  async function firstLoadCategories() {
    try {
      const { data } = await axios.get(
        `/api/v1/admin/operators/rules/${id}/categories`
      );
      const { categories, selected, selectedRules } = data;
      dispatch({ type: 'SELECT_RULES', payload: selectedRules });
      for (const category of categories) {
        category.count = selected[category._id];
      }
      dispatch({ type: 'CATEGORIES', payload: categories });
    } catch (error) {
      showError(error);
    }
  }
  const selectCategory = (category) => {
    dispatch({ type: 'SELECT_CATEGORY', payload: category });
  };
  const flushRules = () => {
    dispatch({ type: 'RULES', payload: { rules: [] } });
  };
  const loadRules = async (catId) => {
    try {
      const { data } = await axios.get(
        `/api/v1/admin/operators/rules/${id}/category/${catId}`
      );
      dispatch({
        type: 'RULES',
        payload: { rules: data.rules },
      });
    } catch (error) {
      showError(error);
    }
  };
  const selectRules = (ruleIds) => {
    dispatch({ type: 'SELECT_RULES', payload: ruleIds });
  };
  const setRules = async () => {
    try {
      const { data } = await axios.post(`/api/v1/admin/operators/rules/`, {
        rules: state.selectedRules,
        operatorId: id,
      });
    } catch (error) {
      showError(error);
    }
  };
  const refresh = () => {
    handleFetchUser();
    firstLoadCategories();
  };
  const transferRules = async (destOperatorId, sourceOperatorId) => {
    try {
      const { data } = await axios.post(`/api/v1/admin/rules/transferRules`, {
        destOperatorId,
        sourceOperatorId,
      });
      if (data?.ok) showMessage(data?.messages);
      refresh();
    } catch (error) {
      showError(error);
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      firstLoadCategories();
      isFirstRender.current = false;
    }
  }, [selectedRules]);

  useEffect(() => {
    if (mode === 'edit') {
      handleFetchUser();
    }
  }, [mode]);

  return (
    <Provider
      value={{
        state,
        dispatch,
        refresh,
        loadCategories,
        selectCategory,
        selectRules,
        setRules,
        loadRules,
        transferRules,
        flushRules,
        validation,
        showError,
        showMessage,
      }}
    >
      <FullCard
        title={mode === 'add' ? 'افزودن کارشناس حمل' : 'ویرایش کارشناس حمل'}
        category={
          mode === 'add'
            ? 'برای افزودن کارشناس حمل توسط مدیر سیستم'
            : 'ویرایش کارشناس حمل'
        }
      >
        {hasRule('can_manage_operators') ? (
          <div className={classes.root}>
            <div>
              <Form />
              <Divider />
              <WorkTime
                data={state.values.workTime}
                onChange={handleChangeWorkTime}
              />
              <Button
                onClick={handleSubmit}
                variant="contained"
                color="primary"
                style={{ marginTop: 15 }}
                disabled={loading}
                endIcon={loading ? <CircularProgress size={10} /> : <></>}
              >
                {mode === 'add' ? 'افزودن' : 'ویرایش'}
              </Button>
            </div>
            {mode === 'edit' && <Rules />}
          </div>
        ) : (
          <div>شما امکان دسترسی به این بخش را ندارید.</div>
        )}
      </FullCard>
    </Provider>
  );
};

export default React.memo(AddOperator);
